// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
   border-style: solid;
   border-width: 1px;
   border-color: rgba(0, 0, 0, 0.12);
   cursor: unset;
   padding: 5px 10px;
   background-color: white;
}

.txt-field-body {
   border-style: none;
}

.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: -5px;
   margin-left: 6px;
   margin-right: 5px;
   color: red;
}

.validate-error {
   border-color: red;
}

input, label {
   display: block;
}

.no-wrap {
   display: flex;
   margin-right: 10px;
}

.name-field-body .name-width-one .title, .name-field-body .name-width-one .initial,
.name-field-body .name-width-two .title, .name-field-body .name-width-two .initial {
   width: 35%;
}

.name-field-body .name-width-one .title, .name-field-body .name-width-one .form-initial,
.name-field-body .name-width-two .title, .name-field-body .name-width-two .form-initial {
   width: 38%;
}

.name-field-body .name-width-one .surname {
   margin-left: 0px;
}

.field-header, .field-header-address {
   margin: 5px 0 1px 4px;
}

.name-field-body .name-width-one, .name-width-three label {
   cursor: context-menu !important;
}

.name-field-body .name-width-one input {
   cursor: auto !important;
   margin-top: 6px;
}

.name-field-body  .name-width-three input {
   cursor: auto !important;
   margin-top: 8px;
}

.name-field-body .name-width-three label input {
   margin: 4px 10px 10px 10px !important;
   width: 100% !important;
}

.name-field-body .fix-width-three label input{
   margin: 4px 10px 10px 10px !important;
   width: 262px;
}

.name-width-one {
   margin-left: -8px;
}

.name-width-three {
   margin-left: 2px;
   margin-right: 20px;
}

input:focus {
   outline: none !important;
   border: 1px solid rgba(0, 0, 0, 0.35);
}

.name-field-body .name-width-one input, .name-field-body .name-width-two input {
   cursor: auto !important;
}

.name-field-body .name-width-one label, .name-field-body .name-width-two label {
   cursor: auto !important;;
}

.mat-option {
   height: 30px !important;
}

.title-other {
   position: relative;
   display: flex;
}

.input-full {
   width: 100%;
}

.input-half {
   width: 93px !important;
}

.field-two {
   margin: 0 -10px 5px 5px;
}

.field-two .title {
   width: 98%;
   float: left;
   padding: 7px 10px 0 2px;
   margin-right: 8px;
}
.field-two .initial, .field-two .name, .field-two .surname, .field-two .middle {
   width: 48%;
   float: left;
   padding: 7px 12px 0 2px;
   margin-right: 8px;
}

.width-two {
   width: 165px;
}

.width-three {
   width: 80%;
}

.set-height{
   height: 80px;
}

.txt-field-body input:not(.fwidth-two), .txt-field-body textarea {
   margin: 5px 10px 10px 6px !important;
}

.txt-field-body input.input-full {
   margin-right: -4px !important;
}

.txt-field-body .input-other-flex-two input {
   margin: 5px 10px 10px 6px !important;
}

.name-field-body .name-width-one label{
   padding: 0 6px 1px 14px !important;
}

.field-header-three {
   margin: 5px 5px 1.125pt 8px;
}

.requireAlert {
   margin-left: 10px;
}

.name-field-body {
   overflow: hidden;
}

.field-header-two {
   margin: 4px 5px 1px 10px;
}

.field-header-label {
   margin: 4px 5px 6px 10px;
}

.field-header-label-three {
   margin: 4px 5px 1.25pt 10px;
}

.title-other .fwidth-two {
   margin: 5px -15px 10px 1px !important;
   width: 100% !important;
}

.set-title-other{
   margin: 0 -10px 15px 3px !important;
}

.fwidth-one {
   width: 45% !important;
}

.field-header-no-title {
   margin: 15px 5px 1.125pt 8px;
}

.title-flex {
   flex: 1;
}

.title-flex input {
   width: 100% !important;
   margin-left: 10px !important;
}

.title-flex-name-half {
   flex: 1;
}

.title-flex-name-half input {
   width: 47.5% !important;
}

.title-flex-name {
   flex: 1;
}

.title-flex-name input {
   width: 98% !important;
}

.input-other-flex {
   position: relative;
   display: flex;
   flex-direction: column;
}

.input-other-flex-two {
   position: relative;
   display: flex;
   flex-direction: column;
   padding-left: 18px;
}

`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/name/name.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;GACnB,iBAAiB;GACjB,iCAAiC;GACjC,aAAa;GACb,iBAAiB;GACjB,uBAAuB;AAC1B;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,gBAAgB;GAChB,gBAAgB;GAChB,iBAAiB;GACjB,UAAU;AACb;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,aAAa;GACb,kBAAkB;AACrB;;AAEA;;GAEG,UAAU;AACb;;AAEA;;GAEG,UAAU;AACb;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,+BAA+B;AAClC;;AAEA;GACG,uBAAuB;GACvB,eAAe;AAClB;;AAEA;GACG,uBAAuB;GACvB,eAAe;AAClB;;AAEA;GACG,qCAAqC;GACrC,sBAAsB;AACzB;;AAEA;GACG,qCAAqC;GACrC,YAAY;AACf;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,wBAAwB;GACxB,qCAAqC;AACxC;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,kBAAkB;GAClB,aAAa;AAChB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,UAAU;GACV,WAAW;GACX,uBAAuB;GACvB,iBAAiB;AACpB;AACA;GACG,UAAU;GACV,WAAW;GACX,uBAAuB;GACvB,iBAAiB;AACpB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,oCAAoC;AACvC;;AAEA;GACG,6BAA6B;AAChC;;AAEA;GACG,oCAAoC;AACvC;;AAEA;GACG,kCAAkC;AACrC;;AAEA;GACG,2BAA2B;AAC9B;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,2BAA2B;AAC9B;;AAEA;GACG,qCAAqC;GACrC,sBAAsB;AACzB;;AAEA;GACG,mCAAmC;AACtC;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,4BAA4B;AAC/B;;AAEA;GACG,OAAO;AACV;;AAEA;GACG,sBAAsB;GACtB,4BAA4B;AAC/B;;AAEA;GACG,OAAO;AACV;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,OAAO;AACV;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,kBAAkB;GAClB,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,kBAAkB;GAClB,aAAa;GACb,sBAAsB;GACtB,kBAAkB;AACrB","sourcesContent":["input {\n   border-style: solid;\n   border-width: 1px;\n   border-color: rgba(0, 0, 0, 0.12);\n   cursor: unset;\n   padding: 5px 10px;\n   background-color: white;\n}\n\n.txt-field-body {\n   border-style: none;\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: -5px;\n   margin-left: 6px;\n   margin-right: 5px;\n   color: red;\n}\n\n.validate-error {\n   border-color: red;\n}\n\ninput, label {\n   display: block;\n}\n\n.no-wrap {\n   display: flex;\n   margin-right: 10px;\n}\n\n.name-field-body .name-width-one .title, .name-field-body .name-width-one .initial,\n.name-field-body .name-width-two .title, .name-field-body .name-width-two .initial {\n   width: 35%;\n}\n\n.name-field-body .name-width-one .title, .name-field-body .name-width-one .form-initial,\n.name-field-body .name-width-two .title, .name-field-body .name-width-two .form-initial {\n   width: 38%;\n}\n\n.name-field-body .name-width-one .surname {\n   margin-left: 0px;\n}\n\n.field-header, .field-header-address {\n   margin: 5px 0 1px 4px;\n}\n\n.name-field-body .name-width-one, .name-width-three label {\n   cursor: context-menu !important;\n}\n\n.name-field-body .name-width-one input {\n   cursor: auto !important;\n   margin-top: 6px;\n}\n\n.name-field-body  .name-width-three input {\n   cursor: auto !important;\n   margin-top: 8px;\n}\n\n.name-field-body .name-width-three label input {\n   margin: 4px 10px 10px 10px !important;\n   width: 100% !important;\n}\n\n.name-field-body .fix-width-three label input{\n   margin: 4px 10px 10px 10px !important;\n   width: 262px;\n}\n\n.name-width-one {\n   margin-left: -8px;\n}\n\n.name-width-three {\n   margin-left: 2px;\n   margin-right: 20px;\n}\n\ninput:focus {\n   outline: none !important;\n   border: 1px solid rgba(0, 0, 0, 0.35);\n}\n\n.name-field-body .name-width-one input, .name-field-body .name-width-two input {\n   cursor: auto !important;\n}\n\n.name-field-body .name-width-one label, .name-field-body .name-width-two label {\n   cursor: auto !important;;\n}\n\n.mat-option {\n   height: 30px !important;\n}\n\n.title-other {\n   position: relative;\n   display: flex;\n}\n\n.input-full {\n   width: 100%;\n}\n\n.input-half {\n   width: 93px !important;\n}\n\n.field-two {\n   margin: 0 -10px 5px 5px;\n}\n\n.field-two .title {\n   width: 98%;\n   float: left;\n   padding: 7px 10px 0 2px;\n   margin-right: 8px;\n}\n.field-two .initial, .field-two .name, .field-two .surname, .field-two .middle {\n   width: 48%;\n   float: left;\n   padding: 7px 12px 0 2px;\n   margin-right: 8px;\n}\n\n.width-two {\n   width: 165px;\n}\n\n.width-three {\n   width: 80%;\n}\n\n.set-height{\n   height: 80px;\n}\n\n.txt-field-body input:not(.fwidth-two), .txt-field-body textarea {\n   margin: 5px 10px 10px 6px !important;\n}\n\n.txt-field-body input.input-full {\n   margin-right: -4px !important;\n}\n\n.txt-field-body .input-other-flex-two input {\n   margin: 5px 10px 10px 6px !important;\n}\n\n.name-field-body .name-width-one label{\n   padding: 0 6px 1px 14px !important;\n}\n\n.field-header-three {\n   margin: 5px 5px 1.125pt 8px;\n}\n\n.requireAlert {\n   margin-left: 10px;\n}\n\n.name-field-body {\n   overflow: hidden;\n}\n\n.field-header-two {\n   margin: 4px 5px 1px 10px;\n}\n\n.field-header-label {\n   margin: 4px 5px 6px 10px;\n}\n\n.field-header-label-three {\n   margin: 4px 5px 1.25pt 10px;\n}\n\n.title-other .fwidth-two {\n   margin: 5px -15px 10px 1px !important;\n   width: 100% !important;\n}\n\n.set-title-other{\n   margin: 0 -10px 15px 3px !important;\n}\n\n.fwidth-one {\n   width: 45% !important;\n}\n\n.field-header-no-title {\n   margin: 15px 5px 1.125pt 8px;\n}\n\n.title-flex {\n   flex: 1;\n}\n\n.title-flex input {\n   width: 100% !important;\n   margin-left: 10px !important;\n}\n\n.title-flex-name-half {\n   flex: 1;\n}\n\n.title-flex-name-half input {\n   width: 47.5% !important;\n}\n\n.title-flex-name {\n   flex: 1;\n}\n\n.title-flex-name input {\n   width: 98% !important;\n}\n\n.input-other-flex {\n   position: relative;\n   display: flex;\n   flex-direction: column;\n}\n\n.input-other-flex-two {\n   position: relative;\n   display: flex;\n   flex-direction: column;\n   padding-left: 18px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
